export default __webpack_public_path__ + "static/media/IconDesc_FloodlightWall.256.ecb7f7a1.png";